import classNames from 'classnames';
import { FunctionalComponent, h } from 'preact';

type Props = {
    id?: string;
    children?: any;
    className?: string;
    colored?: boolean;
    heading?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    inverted?: boolean;
};

export const Title: FunctionalComponent<Props> = ({
    inverted,
    colored,
    children,
    className,
    heading: Heading = 'h2',
    ...rest
}) => (
    <Heading
        className={classNames('c-title', className, {
            'c-title--inverted': inverted,
            'c-title--colored': colored,
        })}
        {...rest}
    >
        {children}
    </Heading>
);
